<template>
    <div class="page">
        <grid />
        <div class="page-container">
            <div :class="['missing-page first-block', {'white-text': whiteText}]">
                <h1 v-if="pageTitle">{{pageTitle}}</h1>
                <div  v-if="content" :class="['content-container']" v-html="content"></div>
                <div class="buttons">
                    <button-link v-for="(button, index) in button_list" :key="index" v-if="button_list" v-bind="button" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../utils/EventBus';
    import Grid from "../modules/svgs/Grid";
    import ButtonLink from '../modules/components/ButtonLink'

    export default {
        name: "Page404",
        components: { Grid, ButtonLink },
        mounted(){
            document.body.classList.add('page-not-found');
        },
        beforeDestroy(){
            document.body.classList.remove('page-not-found');
        },
        computed: {
            settings() {
                return wp && wp.settings && wp.settings.settings_404;
            },
            isMobile() {
                return EventBus.isMobile
            },
            pageTitle(){
                return this.settings.title;
            },
            button_list(){
                return this.settings.button_list;
            },
            whiteText(){
                return this.settings.white_text;
            },
            content() {
                const content = this.settings.copy;
                if (content) {
                    this.$emit('pageLoaded');
                    return content;
                }
                return false;
            },
        },
    }
</script>

<style lang="scss" scoped>

    .buttons{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 40px;

        div{
            margin: 15px;
        }
    }

    .page-container{
        max-width: 700px;
        text-align: center;
        position: relative;
        z-index: 10;
    }

    .first-block {
        padding-top: 380px;
    }

    h1{
        opacity: .5;
        font-weight: 600;
        font-size: 75px;
        line-height: 75px;
        margin-bottom: 50px;
    }

    .white-text{
        color: #fff;

        h1{
            color: #fff;
        }
    }

</style>